import { render, staticRenderFns } from "./App.vue?vue&type=template&id=7df78084&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
import style0 from "./App.vue?vue&type=style&index=0&id=7df78084&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df78084",
  null
  
)

export default component.exports